import actionCreatorFactory from 'typescript-fsa';

const ac = actionCreatorFactory();

export default {
  forgotPassword: ac<string>('forgotPassword'),
  resetPassword: ac<{ token: string; newPassword: string }>('resetPassword'),
};
